 <div class="home-wrapper">
    <app-header></app-header>
    <div class="home">
        <!-- <div class="d-flex flex-column align-items-center justify-content-center"> -->
        <div>
            <div class="title-wrapper">
                <div class="title-header">{{ 'msg#welcome.header' | sqMessage }}</div>
                <div class="title">{{ 'msg#welcome.content' | sqMessage }}</div>
                <div class="title-footer">{{ 'msg#welcome.footer' | sqMessage }}</div>
                <div class="title-content"><h6>{{ 'msg#welcome.title' | sqMessage }}</h6>
                    <p class="upload">{{'msg#label.upload' |
                        sqMessage}} <a href="https://azcollaboration.sharepoint.com/sites/TSN760" target="_blank">
                            <strong>{{'msg#label.uploadURL' |
                                sqMessage}}</strong></a></p>
                </div>
                <p class="upload mobile-hide">{{'msg#label.upload' |
                    sqMessage}} <a href="https://azcollaboration.sharepoint.com/sites/TSN760" target="_blank">
                        <strong>{{'msg#label.uploadURL' |
                            sqMessage}}</strong></a></p>

                            <div class="search-wrapper">
                                <app-search-form [hideSearch]="true"></app-search-form>
                                <!-- <app-search-form [autocompleteSources]="features"><i class="fa fa-search" aria-hidden="true"></i></app-search-form> -->
                                  
                            </div>
                            <div class="count-section"  > 

                                <ng-container *ngIf="(esService.totalCount | async) as count">
                                    <div class="col-12" style="width: 568px;" *ngIf="count['totalrowcount']">
                                        {{count['totalrowcount'] | number}} records available
                                        <!-- {{'msg#results.resultsCount' | sqMessage:{values: {count: counts.totalrowcount} } -->
                        <!-- }} -->
                                    </div>   
                                </ng-container>
                                

                            </div> 
                            
                            <div class="disclaimer">
                               <h5> An AI Assistant service has been added to Insight Vault for Pilot testing.</h5>
                                <ul class="warning-list">
                                    <li>Do not use the public version of ChatGPT or other Large Language Models (Claude, llama etc) <b>to conduct AZ work</b>. Always use AZ services, which are safe and secure.</li> 
                                    <li>It is important to use the Insight Vault Assistant in a safe, responsible and compliant way, in accordance with AZ's <a href="https://azusgb01--cms.vf.force.com/apex/Main?sname=Intranet&name=AIGovernance" target="_blank"><b>AI Governance framework</b></a>. This means:
                                        <ul>
                                            <li>Insight Vault Assistant must only be used by AZ users, in approved countries, who have been granted access.</li>
                                            <li>Insight Vault Assistant must not be made available to or shared with non-AZ users.</li>
                                            <li>Insight Vault Assistant must not be made publicly available or used in any public-facing contexts (e.g., with HCPs, patients, customers etc.).</li>
                                            <li>Do not share your log in credentials with anyone.</li>
                                        </ul>
                                    </li>
                                    <li>Users must review and verify the accuracy, truthfulness, safety, and appropriateness of AI outputs, prior to sharing, relying on or using those outputs.</li>
                                    <li>Users must review and assess whether AI outputs are harmful or biased, prior to sharing, relying on or using those outputs</li>
                                    <li>Users must promptly report serious issues, concerns, errors from the use of Insight Vault Assistant by raising a ticket with ASKIT</li>
                                    <li>End users must ensure AI generated outputs are meaningfully reviewed by a human reviewer before being used to make decisions regarding individuals.</li>
                                    <li>Do not upload external data (including academic / journal publications), without checking that AZ is licensed to use this data in an AI application. For advice, please contact the External Content Licensing Team (Enterprise Data Office).</li>
                                    <li>Do not submit any personal data when using Insight Vault Assistant.</li>
                                    <li>By using this service, I confirm that I have read and understood the above and will not enter any sensitive personal information.</li>
                                </ul>
                                <h6>Limitations</h6>
                                <ul class="warning-list">
                                    <li>May occasionally generate incorrect information</li>
                                    <li>May produce harmful instructions or biased content</li>
                                </ul>
                            </div>
            </div>
            
            
        </div>
    </div>
    <app-footer></app-footer>
</div>